import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import ResultInt from '../../_interface/result-int';
import NebulaModuleBase from './module-base';
export var UpNetwork = function (_NebulaModuleBase) {
    _inherits(UpNetwork, _NebulaModuleBase);

    function UpNetwork() {
        _classCallCheck(this, UpNetwork);

        var _this = _possibleConstructorReturn(this, (UpNetwork.__proto__ || Object.getPrototypeOf(UpNetwork)).apply(this, arguments));

        _this.netStatusListeners = new Map();
        return _this;
    }

    _createClass(UpNetwork, [{
        key: 'isOnline',
        value: function isOnline() {
            return this.generatePromiseByFunctionWithParams('isOnlineForNetwork', null);
        }
    }, {
        key: 'isOnlinePing',
        value: function isOnlinePing() {
            return this.generatePromiseByFunctionWithParams('isOnlinePingForNetwork', null);
        }
    }, {
        key: 'getNetworkInfo',
        value: function getNetworkInfo() {
            return this.generatePromiseByFunctionWithParams('getNetworkInfoForNetwork', null);
        }
    }, {
        key: 'addNetStateEventListener',
        value: function addNetStateEventListener(onNetStatusChangeListener, key) {
            this.netStatusListeners.set(key, onNetStatusChangeListener);
            if (this.netStatusListeners.size === 1) {
                var event = 'NetworkChanged';
                var params = { eventName: event };
                return this.generatePromiseByAttachListenerWithParams(event, this.onNetStatusChangeCallback, 'addNetStateEventListenerForNetwork', params);
            } else {
                return Promise.resolve(new ResultInt('000000', '\u6DFB\u52A0NetworkChanged\u76D1\u542C\u5668\u6210\u529F'));
            }
        }
    }, {
        key: 'removeNetStateEventListener',
        value: function removeNetStateEventListener(key) {
            this.netStatusListeners['delete'](key);
            window.console.info('removeNetStateEventListener, key: ' + key);
            if (this.netStatusListeners.size === 0) {
                var event = 'NetworkChanged';
                var params = { eventName: event };
                return this.generatePromiseByDetachListenerWithParams(event, this.onNetStatusChangeCallback, 'removeNetStateEventListenerForNetwork', params);
            }
            return Promise.resolve(new ResultInt('000000', '\u79FB\u9664NetworkChanged\u76D1\u542C\u5668\u6210\u529F'));
        }
    }, {
        key: 'onNetStatusChangeCallback',
        value: function onNetStatusChangeCallback(data) {
            window.console.info('receiveNetworkChanged event, data: ' + data);
            this.netStatusListeners.forEach(function (item) {
                item(data);
            });
        }
    }]);

    return UpNetwork;
}(NebulaModuleBase);